import { create } from 'zustand'
import api from '../services/api'

interface MePermissionsResponse {
  is_superadmin: boolean
  resources: Record<string, string[]>
  email?: string
}

interface PermissionState {
  isSuperadmin: boolean
  resources: Record<string, string[]>
  email: string | null
  loaded: boolean
  loading: boolean
  fetchPermissions: () => Promise<void>
  hasPermission: (resource: string, action: string) => boolean
  hasResource: (resource: string) => boolean
  reset: () => void
}

export const usePermissionStore = create<PermissionState>((set, get) => ({
  isSuperadmin: false,
  resources: {},
  email: null,
  loaded: false,
  loading: false,

  fetchPermissions: async () => {
    if (get().loading) return
    set({ loading: true })
    try {
      const res = await api.get<MePermissionsResponse>('/me/permissions')
      console.log('[permissionStore] permissions loaded:', res.data)
      set({
        isSuperadmin: res.data.is_superadmin,
        resources: res.data.resources ?? {},
        email: res.data.email ?? null,
        loaded: true,
        loading: false,
      })
    } catch (e) {
      console.error('[permissionStore] fetchPermissions error:', e)
      set({ loaded: true, loading: false })
    }
  },

  hasPermission: (resource, action) => {
    const { isSuperadmin, resources } = get()
    if (isSuperadmin) return true
    const actions = resources[resource]
    if (!actions) return false
    return actions.includes(action)
  },

  hasResource: (resource) => {
    const { isSuperadmin, resources } = get()
    if (isSuperadmin) return true
    return resource in resources
  },

  reset: () => {
    set({ isSuperadmin: false, resources: {}, email: null, loaded: false, loading: false })
  },
}))
